import {
  MaterialReactTable,
  MRT_ColumnDef,
  MRT_TableOptions,
  useMaterialReactTable
} from "material-react-table";

interface GlobalTableProps {
  columns: MRT_ColumnDef<any>[];
  data: any[];
  config?: Omit<MRT_TableOptions<any>, "columns" | "data">;
}

export function GlobalTable({ columns, data, config }: GlobalTableProps) {
  const table = useMaterialReactTable({
    columns,
    data: data || [],
    defaultDisplayColumn: { enableResizing: true },
    enableBottomToolbar: false,
    enableColumnResizing: false,
    enableColumnVirtualization: true,
    enableGlobalFilterModes: false,
    enableFullScreenToggle: false,
    enableMultiSort: false,
    manualSorting: false,
    manualFiltering: false,
    muiTableHeadRowProps: {
      sx: {
        borderBottom: `1px solid inherit !important`,
        boxShadow: "none !important",
        "& tr": {
          boxShadow: "none !important"
        }
      }
    },

    initialState: {
      showGlobalFilter: true
    },
    enableHiding: false,
    enableDensityToggle: false,
    enablePagination: false,
    enableRowVirtualization: true,
    enableColumnActions: false,
    muiTableContainerProps: {
      sx: {
        minHeight: 370,
        maxHeight: 370
      }
    },
    muiTableBodyRowProps: () => ({
      hover: false
    }),
    muiTableBodyCellProps: (cell) => ({
      sx: {
        height: "auto !important"
      }
    }),
    ...config
  });

  return <MaterialReactTable table={table} />;
}
